"use client";

import { useEffect } from "react";

const RELOAD_KEY = "devkrest-chunk-reload";

function isChunkLoadError(message: string): boolean {
  return (
    message.includes("Loading chunk") ||
    message.includes("ChunkLoadError") ||
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("error loading dynamically imported module")
  );
}

function attemptReload(): void {
  const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
  if (!hasReloaded) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
}

export default function ChunkErrorRecovery() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (isChunkLoadError(event.message || "")) {
        attemptReload();
      }
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const message =
        reason instanceof Error ? reason.message : String(reason ?? "");
      if (isChunkLoadError(message)) {
        attemptReload();
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    sessionStorage.removeItem(RELOAD_KEY);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  return null;
}
